import React, { useState, useEffect } from "react";

function Halving() {
  const [halvingDay, setHalvingDay] = useState("");
  const [pct, setPct] = useState(0);
  const [currReward, setCurrReward] = useState(0);
  const [nextReward, setNextReward] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("stats/halving")
      .then((resp) => resp.json())
      .then((data) => {
        setHalvingDay(data.next_halving_day);
        setPct(data.pct_till_next_halving);
        setCurrReward(data.current_block_reward);
        setNextReward(data.next_block_reward);
        setLoading(false);
      })
      .catch((err) => console.log(err.message));
  }, []);

  // read any global variable from window.
  window.google.charts.load("current", { packages: ["bar"] });
  window.google.charts.setOnLoadCallback(() => drawChart(pct));

  return (
    <div className="mbox">
      <h4 className="text-center" title="Bitcoin halving is an event where the Bitcoin mining reward is halved. A halving event occurs every 210,000 blocks, which is about once every 4 years.">
        <i className="bi bi-square-half" style={{ color: "#8B8000" }}></i> Bitcoin
        Halving
      </h4>
      <hr />
      {loading ? (
        <div className="text-center" style={{ fontStyle: "italic" }}>
          Loading...
        </div>
      ) : (
        <div className="h6 text-center">
          Next Halving Day (ETA):{" "}
          <span style={{ color: "darkgreen", fontWeight: "bold" }}>
            {halvingDay}
          </span>
        </div>
      )}
      <div
        id="divChart"
        style={{ width: 300, height: 120, marginLeft: 10 }}
      ></div>

      <table className="table table-striped">
        <tbody>
          <tr>
            <th>Current Block Reward: </th>
            <td>{currReward} BTC</td>
          </tr>
          <tr>
            <th>Next Block Reward: </th>
            <td>{nextReward} BTC</td>
          </tr>
        </tbody>
      </table>
      
      <table style={{ fontSize: 11 }}>
        <tbody>
          <tr>
            <td width="60%"><span className="p-2">source: blockchain.info</span></td>
            <td width="40%"><a href="/info/halving" style={{ fontWeight: 'bold'}}>Bitcoin Halving Schedules</a></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

function drawChart(pct) {
  const google = window.google;

  var pctRemaining = 100 - pct;
  var data = google.visualization.arrayToDataTable([
    ["Label", "Current", "Remaining", { role: "style" }],
    ["Next Halving", pct, pctRemaining, "lightblue"],
  ]);

  var options = {
    isStacked: "percent",
    width: 300,
    height: 100,
    legend: { position: "none" },
  };

  var chart = new google.visualization.BarChart(
    document.getElementById("divChart")
  );
  chart.draw(data, options);
}

export default Halving;
